import { emagentApi } from './emagentApi';

export type UsageByUserRow = {
  userId: string;
  inputTokens: number;
  outputTokens: number;
  totalTokens: number;
  recordCount: number;
};

export type AdminUsageRecord = {
  id: string;
  userId: string;
  containerId: string;
  runId: string;
  bizCode: string | null;
  providerId: string;
  modelId: string;
  mode: string;
  inputTokens: number;
  outputTokens: number;
  totalTokens: number;
  createdAt: string;
};

export async function fetchUsageByUser(params: {
  from: string;
  to: string;
  bizCode?: string;
  userId?: string;
  limit?: number;
  offset?: number;
}): Promise<{ items: UsageByUserRow[]; total: number }> {
  const q = new URLSearchParams();
  q.set('from', params.from);
  q.set('to', params.to);
  if (params.bizCode !== undefined) q.set('bizCode', params.bizCode);
  if (params.userId) q.set('userId', params.userId);
  if (params.limit != null) q.set('limit', String(params.limit));
  if (params.offset != null) q.set('offset', String(params.offset));
  const res = await emagentApi.get<{ items: UsageByUserRow[]; total: number }>(
    `/admin/usage/by-user?${q.toString()}`,
  );
  return res.data;
}

export async function fetchAdminUsageHistory(
  userId: string,
  params: {
    from: string;
    to: string;
    bizCode?: string;
    limit?: number;
    offset?: number;
  },
): Promise<{ items: AdminUsageRecord[]; total: number }> {
  const q = new URLSearchParams();
  q.set('from', params.from);
  q.set('to', params.to);
  if (params.bizCode !== undefined) q.set('bizCode', params.bizCode);
  if (params.limit != null) q.set('limit', String(params.limit));
  if (params.offset != null) q.set('offset', String(params.offset));
  const res = await emagentApi.get<{ items: AdminUsageRecord[]; total: number }>(
    `/admin/usage/users/${encodeURIComponent(userId)}/history?${q.toString()}`,
  );
  return res.data;
}
